import { render, staticRenderFns } from "./AnnotationSuggestion.vue?vue&type=template&id=316d55cf&scoped=true"
import script from "./AnnotationSuggestion.vue?vue&type=script&lang=js"
export * from "./AnnotationSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d55cf",
  null
  
)

export default component.exports